import React from 'react';
import { createSvgIcon } from '@mui/material';
export default createSvgIcon(React.createElement("path", { d: "M6,12a6,6 0 1,0 12,0a6,6 0 1,0 -12,0" }), 'RadioButtonOn');
